import { css, keyframes } from 'styled-components';

/*
  below are used for react-transition-group which allow animation
  of components entering and exiting the dom
  Transition component docs: http://reactcommunity.org/react-transition-group/transition
*/
export enum VALID_TRANSITION_STATES {
  entered = 'entered',
  entering = 'entering',
  exiting = 'exiting',
  exited = 'exited',
}

export interface ITransitionStates {
  transitionState: VALID_TRANSITION_STATES;
}

export const fadeInOut = css<ITransitionStates>`
  opacity: ${({ transitionState }) => {
    switch (transitionState) {
      case VALID_TRANSITION_STATES.entered:
        return 1;
      case VALID_TRANSITION_STATES.entering:
        return 0;
      case VALID_TRANSITION_STATES.exiting:
        return 0;
      default:
        return 0;
    }
  }};
`;

/* end react-transition-group */

export const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: 0;
  }
`;

export const fadeOutDown = keyframes`
  from {
    opacity: 1;
    top: 0;
  }

  to {
    opacity: 0;
    top: 100px;
  }
`;

export const slideInUp = keyframes`
  from {
    bottom: -100px;
  }

  to {
    bottom: 0;
  }
`;

export const slideOutDown = keyframes`
  from {
    bottom: 0;
  }

  to {
    bottom: -100px;
  }
`;
